<template>
    <div id="lead-in-vue">
        <h1>Jordan Foreman <span>&amp;</span> Maggi Vodraska</h1>
        <p>...invite you to share in our special day!</p>
        <h3>When</h3>
        <p>September 8, 2018</p>
    </div>
</template>

<script>
export default {
    name: 'lead-in-view',
    data: () => ({})
};
</script>



// WEBPACK FOOTER //
// src/views/lead-in.vue?1ad6ddd1